import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const checkoutUrl = 'https://figure-skating-ready.impultienda.ar/checkout';
const productImage = 'https://cdn.magicpatterns.com/uploads/jceMyTgGrxftyVx2zACFb8/ChatGPT-Image-21-jul-2026_-09_07_31-p.m..webp';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds > 0) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes > 0) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours > 0) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 1,
          minutes: 30,
          seconds: 5
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <section id="pricing" className="scroll-mt-2 border-y-4 border-brand-gold/45 bg-brand-frost px-4 py-5 sm:px-6" aria-labelledby="offer-heading" data-id="element-115" data-mp="2sqwxewpb7vcf">
      <div className="mb-3 text-center" data-id="element-116" data-mp="37idr1dy3a1kp">
        <p id="offer-heading" className="mb-1 text-[10px] font-extrabold tracking-widest text-brand-gold" data-id="element-117" data-mp="37li1uu627vkc">SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM</p>
        <p className="mb-2 text-xs font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-118" data-mp="2xsu868adm7pu">Get instant access today and completely transform the way you plan and deliver figure skating practices.</p>
        <p className="mb-2 text-xs font-extrabold text-brand-navy sm:text-sm" data-id="element-119" data-mp="2otgz3gq5zl5n">⛸️ FIGURE SKATING READY™ — Complete 6-in-1 Planning System</p>
        <a href="#pricing" className="block" data-id="element-120" data-mp="29x82kmxnrlwx"><img src={productImage} alt="Figure Skating Ready planning system" className="mx-auto w-full max-w-[210px] object-contain drop-shadow-lg" data-id="element-121" data-mp="2eurqyfo2lf2l" /></a>
      </div>
      <div className="mb-3 rounded-lg border-4 border-brand-gold bg-white p-3 text-center shadow-xl" data-id="element-122" data-mp="853bfdnzgsn9">
        <p className="text-xs font-semibold text-brand-ink" data-id="element-123" data-mp="d2llj7dqldwu">Regular Price: <span className="line-through" data-id="element-124" data-mp="bn95clicsxbm">$97</span></p>
        <p className="mt-1 text-sm font-extrabold text-red-600" data-id="element-125" data-mp="bjv45glfeu5r">🔥 72% OFF — LIMITED-TIME LAUNCH OFFER</p>
        <p className="my-1 text-4xl font-extrabold leading-none text-brand-navy sm:text-5xl" data-id="element-126" data-mp="1o1ty3v6jcr5">Today Only: $27 USD</p>
        <p className="text-[10px] font-medium text-brand-ink" data-id="element-127" data-mp="3ts43sw2sj09a">Pay securely in your local currency.</p>
        <div className="my-3 rounded border border-red-200 bg-red-50 p-2" data-id="element-128" data-mp="ud8raziwdwat">
          <p className="mb-1.5 text-[11px] font-extrabold leading-tight text-red-600" data-id="element-129" data-mp="uejxf5ztfg53">🔥 Last Chance! This special price expires when the countdown reaches zero.</p>
          <div className="flex justify-center gap-2 text-brand-navy" data-id="element-130" data-mp="klcstncwg462">
            <TimeBox label="HOURS" value={timeLeft.hours} data-id="element-131" data-mp="gm3xie27ny8e" /><span className="pt-1 text-lg font-bold" data-id="element-132" data-mp="gj7z6omgb7jf">:</span><TimeBox label="MINUTES" value={timeLeft.minutes} data-id="element-133" data-mp="1d3gnexo6jmhi" /><span className="pt-1 text-lg font-bold" data-id="element-134" data-mp="1d5bc8n2knyqv">:</span><TimeBox label="SECONDS" value={timeLeft.seconds} data-id="element-135" data-mp="18c8d7zf0zx3a" />
          </div>
        </div>
        <CTAButton href={checkoutUrl} data-id="element-136" data-mp="2qzrvja6rydei">🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-1 text-[11px] font-bold text-brand-navy sm:flex-row sm:gap-4" data-id="element-137" data-mp="2vxjj5s0dzdcw"><span className="flex items-center gap-1" data-id="element-138" data-mp="2zz55e3yt93zr"><StarIcon className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" data-id="element-139" data-mp="3029f1gv1orxt" />4.9/5 — Verified Coach Reviews</span><span className="flex items-center gap-1" data-id="element-140" data-mp="39y434ri1ff7z"><ShieldCheckIcon className="h-3.5 w-3.5 text-brand-ice" data-id="element-141" data-mp="39x1e6p49zmup" />7-Day Money-Back Guarantee — Zero Risk</span></div>
    </section>;
}
function TimeBox({
  label,
  value
}: {
  label: string;
  value: number;
}) {
  return <div data-id="element-142" data-mp="3jp71hljl1g3k"><div className="rounded bg-brand-navy px-2 py-1 text-lg font-extrabold leading-none text-white" data-id="element-143" data-mp="3jofj5cezxev8">{String(value).padStart(2, '0')}</div><p className="mt-0.5 text-[8px] font-bold tracking-wide" data-id="element-144" data-mp="3nrbt6eqh02nk">{label}</p></div>;
}